import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import BodyTextLarge from 'Components/ComponentLibrary/Atoms/Text/BodyTextLarge';
import HeadlineTextLarge from 'Components/ComponentLibrary/Atoms/Text/HeadlineTextLarge';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride('name', { _component: () => HeadlineTextLarge }, { ordinal: 200 })
  .nameOverride('informationText', { _component: () => BodyTextLarge }, { ordinal: 200 });
